import { useGetSystemComplianceTabDataById } from "@features/ax/assetRegistry/systems/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Tabs } from "@shared/ui/tabs";
import { AlertCircle, CheckCircle } from "lucide-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { HistoryLanding } from "./tabs/history";
import { OverviewLanding } from "./tabs/overview";

export const ComplianceLanding: React.FC = () => {
  const { systemId } = useParams();
  useEffect(() => {
    logEvent("compliance_tab_viewed");
  }, []);

  const { data: complianceData } = useGetSystemComplianceTabDataById(
    Number(systemId),
    2
  );
  const urlMapping = {
    overview: "overview",
    history: "history",
  };

  const tabComponents = {
    overview: {
      label: "Overview",
      shortLabel: "Overview",
      component: <OverviewLanding data={complianceData} />,
    },
    history: {
      label: "History",
      shortLabel: "History",
      component: <HistoryLanding />,
    },
  };
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader className="pb-4">
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-green-600" />
                Compliance Status
              </CardTitle>
              {/* <Button variant="outline" size="sm" className="mt-3">
                <Calendar className="h-4 w-4 mr-2" />
                View Full Schedule
              </Button> */}
              {/* Removed for now as per discussion*/}
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Badge className="bg-green-100 text-green-800 text-base px-3 py-1">
                  {complianceData?.complianceStatus?.status}
                </Badge>
              </div>
              <div className="text-sm text-gray-600 space-y-1">
                <div>
                  Samples Taken (This Month):{" "}
                  {complianceData?.complianceStatus?.samplesTakenThisMonth}
                </div>
                <div>
                  Next Sample Due:{" "}
                  {complianceData?.complianceStatus?.nextSampleDue}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-4">
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg flex items-center gap-2">
                <AlertCircle className="h-5 w-5 text-blue-600" />
                Water Quality Compliance
              </CardTitle>
              {/* <Button variant="outline" size="sm" className="mt-3">
                <CheckCircle className="h-4 w-4 mr-2" />
                View Recent Results
              </Button> */}
              {/* Removed for now as per discussion*/}
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Badge className="bg-green-100 text-green-800 text-base px-3 py-1">
                  {complianceData?.waterQualityComplaince?.status}
                </Badge>
              </div>
              <div className="text-sm text-gray-600 space-y-1">
                <div>
                  Parameters Monitored:{" "}
                  {complianceData?.complianceData?.parametersMonitored}
                </div>
                <div>
                  Exceedances (This Month):{" "}
                  {complianceData?.complianceData?.exceedancesThisMonth}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <Tabs
        defaultValue="overview"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="mt-4 grid w-full grid-cols-2 mb-6"
        idPrefix="finance-tab"
        level={1}
      />
    </div>
  );
};
